export const MIN_PHOTO_LONG_SIDE = 1024;
export const MIN_PHOTO_SHORT_SIDE = 720;

export const PHOTO_BELOW_MINIMUM_REASON = `é menor que ${MIN_PHOTO_LONG_SIDE}×${MIN_PHOTO_SHORT_SIDE} pixels`;

export function photoMeetsMinimumDimensions(width: number, height: number): boolean {
  if (width < 1 || height < 1) {
    return false;
  }

  const longSide = Math.max(width, height);
  const shortSide = Math.min(width, height);

  return longSide >= MIN_PHOTO_LONG_SIDE && shortSide >= MIN_PHOTO_SHORT_SIDE;
}

export function readImageDimensions(
  file: File
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      const width = image.naturalWidth;
      const height = image.naturalHeight;
      URL.revokeObjectURL(url);
      resolve({ width, height });
    };

    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("unreadable image"));
    };

    image.src = url;
  });
}
